"use strict";

exports.__esModule = true;
exports.default = void 0;

var isCloudinary = function isCloudinary(url) {
  return typeof url === 'string' && url.includes('cloudinary');
};

var _default = isCloudinary;
exports.default = _default;